import React, {useState, useEffect} from "react";
import {DualImageUploadWrapper, ImageUploadBox, RemoveButton} from "./DualImageUpload.styles";
import UploadImg from "assets/uploadFile2.svg";
import Toast from "components/molecules/Toast";
import {MdDelete} from "react-icons/md";

const DualImageUpload = ({
    onVerticalChange,
    onHorizontalChange,
    verticalImage = "",
    horizontalImage = "",
    maxFileSize = 2, // MB
    accept = "image/jpeg, image/jpg, image/png",
}) => {
    const [verticalPreview, setVerticalPreview] = useState("");
    const [horizontalPreview, setHorizontalPreview] = useState("");

    useEffect(() => {
        if (verticalImage) {
            setVerticalPreview(verticalImage);
        }
    }, [verticalImage]);

    useEffect(() => {
        if (horizontalImage) {
            setHorizontalPreview(horizontalImage);
        }
    }, [horizontalImage]);

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        const acceptableExtensions = accept.split(",").map(ext => ext.trim());
        if (!acceptableExtensions?.includes(file?.type)) {
            const extensions = acceptableExtensions
                .map(ext => ext.split("/")[1].toUpperCase())
                .join(", ")
                .replace(/,(?=[^,]*$)/, " and");

            Toast({
                type: "error",
                message: `File must be in ${extensions} format!`,
            });
            return;
        }

        const fileLength = file.size / (1024 * 1024);
        if (fileLength > maxFileSize) {
            Toast({
                type: "error",
                message: `File size must be less than ${maxFileSize}MB!`,
            });
            return;
        }

        const preview = URL.createObjectURL(file);
        
        if (type === "vertical") {
            setVerticalPreview(preview);
            onVerticalChange(file);
        } else {
            setHorizontalPreview(preview);
            onHorizontalChange(file);
        }
    };

    const handleRemove = (type) => {
        if (type === "vertical") {
            setVerticalPreview("");
            onVerticalChange(null);
            // Reset file input to allow re-uploading the same file
            const input = document.getElementById("vertical-upload");
            if (input) input.value = "";
        } else {
            setHorizontalPreview("");
            onHorizontalChange(null);
            // Reset file input to allow re-uploading the same file
            const input = document.getElementById("horizontal-upload");
            if (input) input.value = "";
        }
    };

    return (
        <DualImageUploadWrapper>
            <div className="section-title">Items Details</div>
            <div className="upload-container">
                {/* Vertical Image Upload */}
                <ImageUploadBox>
                    <label htmlFor="vertical-upload" className="upload-label">
                        {!verticalPreview ? (
                            <div className="upload-content">
                                <img className="upload-icon" src={UploadImg} alt="upload" />
                                <div className="upload-title">Upload Vertical Image</div>
                                <div className="upload-info">Recommended: 1080×1350</div>
                                <div className="upload-info">2MB max, JPG or PNG</div>
                            </div>
                        ) : (
                            <div className="preview-container">
                                <img 
                                    src={typeof verticalPreview === "string" ? verticalPreview : URL.createObjectURL(verticalPreview)} 
                                    alt="Vertical preview" 
                                    className="preview-image"
                                />
                            </div>
                        )}
                        {verticalPreview && (
                            <RemoveButton 
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleRemove("vertical");
                                }}
                            >
                                <MdDelete size={20} />
                            </RemoveButton>
                        )}
                    </label>
                    <input
                        type="file"
                        id="vertical-upload"
                        accept={accept}
                        onChange={(e) => handleFileChange(e, "vertical")}
                        style={{display: "none"}}
                    />
                </ImageUploadBox>

                {/* Horizontal Image Upload */}
                <ImageUploadBox>
                    <label htmlFor="horizontal-upload" className="upload-label">
                        {!horizontalPreview ? (
                            <div className="upload-content">
                                <img className="upload-icon" src={UploadImg} alt="upload" />
                                <div className="upload-title">Upload Horizontal Image</div>
                                <div className="upload-info">Recommended: 1920×1080</div>
                                <div className="upload-info">2MB max, JPG or PNG</div>
                            </div>
                        ) : (
                            <div className="preview-container">
                                <img 
                                    src={typeof horizontalPreview === "string" ? horizontalPreview : URL.createObjectURL(horizontalPreview)} 
                                    alt="Horizontal preview" 
                                    className="preview-image"
                                />
                            </div>
                        )}
                        {horizontalPreview && (
                            <RemoveButton 
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleRemove("horizontal");
                                }}
                            >
                                <MdDelete size={20} />
                            </RemoveButton>
                        )}
                    </label>
                    <input
                        type="file"
                        id="horizontal-upload"
                        accept={accept}
                        onChange={(e) => handleFileChange(e, "horizontal")}
                        style={{display: "none"}}
                    />
                </ImageUploadBox>
            </div>
        </DualImageUploadWrapper>
    );
};

export default DualImageUpload;
